import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import LinkPreviewCard from 'src/components/LinkPreviewCard/LinkPreviewCard';
import calcomBookingDashboardPreview from '../../assets/calcom-booking-dashboard-preview.jpg';
import './key-pickup-invite-intro-callout.scss';

const KeyPickupInviteIntroCallout = () => {
  return (
    <div className="key-pickup-invite-intro-callout">
      <Callout
        variant="info"
        title="Invite homeowners to book key pickups"
        subtitle={
          <>
            Send each unit&apos;s homeowner a link to self-book a key-pickup
            window from your live Cal.com availability. Open a property to pick
            which units to invite.
          </>
        }
      >
        <LinkPreviewCard
          href="https://cal.com/blog/a-complete-walkthrough-of-cal-com-s-booking-dashboard-its-key-features"
          title="See how the Cal.com booking experience works"
          description="What homeowners see when they book, and how bookings are organised in Cal.com."
          siteName="Cal.com"
          image={calcomBookingDashboardPreview}
        />
      </Callout>
    </div>
  );
};

export default KeyPickupInviteIntroCallout;
